module.exports = __webpack_public_path__ + "static/media/CS325WBBB.4c744c93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CS325WBBB.jpg
// module id = 1057
// module chunks = 0